import { useContext, createContext } from 'react'
import { supportedLanguages, SupportedLanguage } from '../lib/i18n'

export interface LanguageContextType {
  currentLanguage: SupportedLanguage;
  changeLanguage: (lang: SupportedLanguage) => Promise<void>;
  supportedLanguages: typeof supportedLanguages;
  isChanging: boolean;
  languageKey: number;
}

// Create context here (in .ts file, not .tsx) to avoid Fast Refresh issues
export const LanguageContext = createContext<LanguageContextType | undefined>(undefined)

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

